import { useEffect, useRef } from 'react'

export function useOutsideClick<T extends HTMLElement = HTMLElement>(
  onClose: () => void,
  enabled = true,
) {
  const ref = useRef<T>(null)

  useEffect(() => {
    if (!enabled) return
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        // Use a small delay so onClick fires before the dropdown unmounts
        setTimeout(onClose, 0)
      }
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [onClose, enabled])

  return ref
}
